import React, {Suspense} from 'react';
import ReactDom from 'react-dom';
import { Router, Route } from 'react-router-dom';

import routes from './router/index';
import { history } from '@/utils';
// 页面加载前处理
import '@/libs/before-load';
// import '@/i18n';
import './i18n';
import '@/utils/fixIOSKeyboard.js';
import LuckLazy from '@/components/LuckLazy';

// 导入样式
// import '$ra1/css/base.less';
import './style/style.less';

// 导入appbridge环境: workstation
import '../../utils/app-api/workstationBridge';

const browserHistory = require("history").createBrowserHistory({basename: 'snackMachine'});
history.setReactRouterHistory(browserHistory);

const Index = () => (
  <Suspense fallback={<LuckLazy/>}>
    <Router history={browserHistory}>
      <div className="wrapper">
        {/* 路由加载 */}
        {[...routes].map((route) => (
          <Route {...route} key={Math.random()}/>
        ))}
      </div>
    </Router>
  </Suspense>
);

ReactDom.render(<Index />, global.document.querySelector('#app'));
